import { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../../../Context/AuthContext';
import ProfilePopover from '../../../../Components/Header/ProfilePopover';
import { url } from '../../../../env';
import { PeicarLogo, IconWhatsApp } from './icons';

/* Ruta del panel según el tipo de usuario (espejo de AdminHeader.dashboardPathFor). */
const dashboardPathFor = (typeUser) => {
  const t = String(typeUser ?? '');
  if (t === '1') return '/admin';
  if (t === '3') return '/admin-trim';
  if (t === '2' || t === '4') return '/vendedor';
  return '/';
};

const getInitials = (name = '') =>
  name.split(' ').filter(Boolean).slice(0, 2).map((w) => w[0]?.toUpperCase()).join('') || '?';

/* ── Header (sticky + blur) ───────────────────────────────────────────── */
const HeaderNuevo = ({ onWhats }) => {
  const { authInfo, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const user = authInfo?.user;
  const [profileOpen, setProfileOpen] = useState(false);

  const handleGoDashboard = () => navigate(dashboardPathFor(user?.type_user));

  const handleLogout = async () => {
    try {
      const token = localStorage.getItem('token');
      await fetch(`${url}/logout`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      });
    } catch (e) { /* best-effort */ }
    logout();
    navigate('/login');
  };

  return (
    <header className="pei-head">
      <div className="inner">
        <a className="brand" href="#top" aria-label="Peicar">
          <PeicarLogo />
          <span className="tag">La llave a tu movilidad</span>
        </a>
        <nav>
          <a href="#credito">¿Crédito?</a>
          <a href="#incluido">Qué incluye</a>
          <a href="#proceso">Cómo funciona</a>
          <a href="#fiscal">Beneficio fiscal</a>
        </nav>
        <div className="actions">
          {authInfo?.isAuth ? (
            <div className="user-wrap" style={{ position: 'relative' }}>
              <button
                className="user-chip"
                onClick={() => setProfileOpen((o) => !o)}
                aria-haspopup="menu"
                aria-expanded={profileOpen}
              >
                <span className="user-av">{getInitials(user?.name)}</span>
                <span className="user-nm">{(user?.name || 'Mi cuenta').split(' ')[0]}</span>
                <svg className="user-cv" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 9l6 6 6-6" /></svg>
              </button>
              <ProfilePopover
                open={profileOpen}
                onClose={() => setProfileOpen(false)}
                user={user}
                onGoDashboard={handleGoDashboard}
                onLogout={handleLogout}
              />
            </div>
          ) : (
            <Link className="login" to="/login">Iniciar sesión</Link>
          )}
          <button className="btn-wa" onClick={onWhats}><IconWhatsApp /><span className="lbl">Hablemos</span></button>
        </div>
      </div>
    </header>
  );
};

export default HeaderNuevo;
